// Mock data for XPO website

export const tradingPartners = [
  { name: 'Binance', logo: 'https://cryptologos.cc/logos/binance-coin-bnb-logo.png' },
  { name: 'Coinbase', logo: 'https://cryptologos.cc/logos/usd-coin-usdc-logo.png' },
  { name: 'Kraken', logo: 'https://cryptologos.cc/logos/ethereum-eth-logo.png' },
  { name: 'MetaTrader', logo: 'https://cryptologos.cc/logos/bitcoin-btc-logo.png' },
  { name: 'Interactive Brokers', logo: 'https://cryptologos.cc/logos/tether-usdt-logo.png' },
];

export const awards = [
  {
    id: 1,
    organization: 'Central European Startup Awards',
    title: 'Startup of the Year',
    year: '2020',
    icon: '🏆'
  },
  {
    id: 2,
    organization: 'Global Forex Awards',
    title: 'Best Affiliate Program',
    year: '2019',
    icon: '🥇'
  },
  {
    id: 3,
    organization: 'Global Forex Awards',
    title: 'Best Partnership Program',
    year: '2020',
    icon: '🎖️'
  },
  {
    id: 4,
    organization: 'FX Empire',
    title: 'Best Customer Experience',
    year: '2022',
    icon: '⭐'
  },
  {
    id: 5,
    organization: 'Central European Startup Awards',
    title: "People's Choice Award",
    year: '2021',
    icon: '🏅'
  }
];

export const howItWorks = [
  {
    id: 1,
    title: 'Easy Onboarding',
    description: 'Register and verify your account in just a few minutes with our streamlined process.',
    icon: 'UserPlus'
  },
  {
    id: 2,
    title: 'Smart Investments',
    description: 'Fund your account and select from our expertly curated index funds.',
    icon: 'TrendingUp'
  },
  {
    id: 3,
    title: 'Achieve More',
    description: 'Grow your portfolio with confidence using our proven strategies.',
    icon: 'Target'
  }
];

export const features = [
  {
    id: 1,
    title: 'Index Fund Performance',
    description: 'XPO provides a way to track the performance of forex, CFD & crypto markets by holding a single index asset. Index funds have consistently beaten average managed funds.',
    icon: 'BarChart3'
  },
  {
    id: 2,
    title: 'Ease & Simplicity',
    description: 'Thousands of trading scripts to choose from. XPO eliminates complexity by providing curated solutions for all kinds of investors.',
    icon: 'Sparkles'
  },
  {
    id: 3,
    title: 'Power of Ideas',
    description: 'We embrace diverse thinking and ideas to create the best outcomes for our clients and their differing investment needs.',
    icon: 'Lightbulb'
  },
  {
    id: 4,
    title: 'Managing with Trust',
    description: 'Trusted to manage over $1.3 trillion in assets, giving clients confidence with our scale, stability, and duty of care.',
    icon: 'Shield'
  }
];

export const cryptoStrategists = [
  {
    id: 1,
    name: 'Alpha Union',
    symbol: '@ALUN',
    weeklyGrowth: 3.47,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
  },
  {
    id: 2,
    name: 'Cloud Trader',
    symbol: '@CLDT',
    weeklyGrowth: 4.44,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
  },
  {
    id: 3,
    name: 'Zhangdang',
    symbol: '@ZHND',
    weeklyGrowth: 3.82,
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop'
  },
  {
    id: 4,
    name: 'Super Crypto',
    symbol: '@SUCP',
    weeklyGrowth: 3.74,
    avatar: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop'
  }
];

export const forexStrategists = [
  {
    id: 1,
    name: 'Diamond FX Index',
    symbol: '@DIMX',
    weeklyGrowth: 2.69,
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
  },
  {
    id: 2,
    name: 'Golden Gate',
    symbol: '@MSMU',
    weeklyGrowth: 3.74,
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
  },
  {
    id: 3,
    name: 'BYK Capital',
    symbol: '@BCAP',
    weeklyGrowth: 3.34,
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop'
  },
  {
    id: 4,
    name: 'Halloween Trade',
    symbol: '@HATRD',
    weeklyGrowth: 4.56,
    avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop'
  }
];

export const trendingIndexes = [
  {
    id: 1,
    name: 'Crypto Notebook',
    symbol: 'CRYNO',
    manager: 'Anisa Zolova',
    topAssets: ['TRX', 'VET', 'DOT', 'XMR'],
    weeklyChange: 3.9,
    monthlyChange: 5.82,
    fundsTrading: 12629364.44
  },
  {
    id: 2,
    name: 'Profit Magnet',
    symbol: 'PRMG',
    manager: 'Alevtina Pavlova',
    topAssets: ['BNB', 'XRP', 'TRX', 'BTC'],
    weeklyChange: 4.31,
    monthlyChange: 5.34,
    fundsTrading: 11727528.42
  },
  {
    id: 3,
    name: 'Metropolis FX',
    symbol: 'METFX',
    manager: 'Larisa Sokolov',
    topAssets: ['NEO', 'VET', 'TRX', 'ADA'],
    weeklyChange: 3.99,
    monthlyChange: 3.2,
    fundsTrading: 10423233.59
  },
  {
    id: 4,
    name: 'Future Chain Index',
    symbol: 'FUCHI',
    manager: 'Anna Zotova',
    topAssets: ['BTC', 'XLM', 'XRP', 'BNB'],
    weeklyChange: 3.73,
    monthlyChange: 5.52,
    fundsTrading: 29924234.82
  },
  {
    id: 5,
    name: 'Index Unicorn',
    symbol: 'UNICR',
    manager: 'Plato Mordvinova',
    topAssets: ['ETH', 'DASH', 'SOL', 'BTC'],
    weeklyChange: 4.36,
    monthlyChange: 5.36,
    fundsTrading: 10723045.65
  }
];

export const liveMarketData = [
  {
    id: 1,
    symbol: 'BTC',
    name: 'Bitcoin',
    price: 67234.52,
    change24h: 2.34,
    volume: '28.5B',
    marketCap: '1.32T',
    icon: 'https://cryptologos.cc/logos/bitcoin-btc-logo.png'
  },
  {
    id: 2,
    symbol: 'ETH',
    name: 'Ethereum',
    price: 3456.78,
    change24h: 1.87,
    volume: '15.2B',
    marketCap: '415.6B',
    icon: 'https://cryptologos.cc/logos/ethereum-eth-logo.png'
  },
  {
    id: 3,
    symbol: 'BNB',
    name: 'Binance Coin',
    price: 598.34,
    change24h: -0.54,
    volume: '1.8B',
    marketCap: '89.2B',
    icon: 'https://cryptologos.cc/logos/binance-coin-bnb-logo.png'
  },
  {
    id: 4,
    symbol: 'SOL',
    name: 'Solana',
    price: 178.92,
    change24h: 5.23,
    volume: '3.4B',
    marketCap: '82.1B',
    icon: 'https://cryptologos.cc/logos/solana-sol-logo.png'
  },
  {
    id: 5,
    symbol: 'XRP',
    name: 'Ripple',
    price: 0.5234,
    change24h: -1.12,
    volume: '1.2B',
    marketCap: '28.9B',
    icon: 'https://cryptologos.cc/logos/xrp-xrp-logo.png'
  },
  {
    id: 6,
    symbol: 'ADA',
    name: 'Cardano',
    price: 0.4567,
    change24h: 3.45,
    volume: '890M',
    marketCap: '16.1B',
    icon: 'https://cryptologos.cc/logos/cardano-ada-logo.png'
  }
];

export const forexRates = [
  { pair: 'EUR/USD', rate: 1.0892, change: 0.15 },
  { pair: 'GBP/USD', rate: 1.2734, change: -0.08 },
  { pair: 'USD/JPY', rate: 154.32, change: 0.23 },
  { pair: 'USD/CHF', rate: 0.8845, change: -0.12 },
  { pair: 'AUD/USD', rate: 0.6589, change: 0.34 },
  { pair: 'USD/CAD', rate: 1.3654, change: -0.05 }
];

export const blogPosts = [
  {
    id: 1,
    title: 'The Role of Cryptocurrency in Emerging Markets',
    excerpt: 'In recent years, cryptocurrencies have transcended their initial hype as speculative assets and begun to make significant impact...',
    date: '15 Dec 2024',
    image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=400&h=250&fit=crop'
  },
  {
    id: 2,
    title: 'The Future of Bitcoin: Trends to Watch',
    excerpt: 'Since its inception in 2009, Bitcoin has captured the imagination of technologists, economists, and investors worldwide...',
    date: '26 Nov 2024',
    image: 'https://images.unsplash.com/photo-1518546305927-5a555bb7020d?w=400&h=250&fit=crop'
  },
  {
    id: 3,
    title: 'Real Stories of Crypto Millionaires',
    excerpt: 'The world of cryptocurrency is filled with tales of meteoric rises and jaw-dropping fortunes. For some, the crypto journey...',
    date: '12 Sep 2024',
    image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=400&h=250&fit=crop'
  }
];

export const companyInfo = {
  description: 'Founded in 2016 with offices across the globe, XPO delivers innovative solutions to the investment management community. From spot to derivative trading solutions through index services and technology products.',
  address: '13/A Tropical Center Rs, London WC1B 4EA',
  phone: '+8 91230 456 788',
  email: 'hello@xpo.ru',
  hours: 'Mon-Sat: 8 am - 5 pm'
};
